<template>
  <div :class="'queue-container'" style="overflow-x:hidden">
    <div class="queue-navbar-container">
      <!-- <Navbar :sharedTime="shared_strategy.time" @menu="toggleStatusTabs" /> -->

      <div class="connecting-block" v-if="!connected">
        <h4>
          <font-awesome-icon icon="wifi" />
          <br />
          {{ $t("queue.connecting_title") }}
        </h4>
        <br />
        <small>{{ $t("queue.connecting_desc") }}</small>
      </div>
      <div v-if="connected && !hideStatusTabs && !anyModalIsActive">
        <!-- <StatusTabs
          :currentTab="currentTab"
          :counters="tabsCounters"
          @switch="switchQueueTab"
        /> -->
        <QueueTabs 
        :currentTab="currentTab"
        :counters="tabsCounters"
        @tabChanged="switchQueueTab"
        :tabs="{
          new: {important: true},
          processing: {important: false},
          done: {important: true},
        }"/>
      </div>
    </div>

    <div v-if="connected && !isDesktop && !anyModalIsActive">
      <button
        class="btn-create-order"
        @click="showOrderCreateUI"
        v-if="this.currentTab == 'new' || this.currentTab == 'processing'"
      >
        + {{ $t("queue.create_order") }}
      </button>

      <div v-if="filteredOrders.length === 0 && awaitingAppends.length === 0">
        <p class="no-orders color-black">{{ $t("queue.no_orders") }}</p>
      </div>
      <div>
        <div v-for="item in filteredOrders" :key="item._id" class="col-width">
          <QueueItem
            :order="item"
            @cancel="showCancelUI"
            @toggleAvailability="handleAvailabilityToggle"
            @accept="showAcceptUI"
            @pay="showPayUI"
            @edit="showEditUI"
            @confirmPay="handleOrderClose"
            @discountChange="handleOrderDiscountChange"
            @changeTable="showMoveUI"
            @merge="showMergeUI"
            @split="showSplitUI"
            @unlock="showUnlockUI"
            @serve="handleOrderServe"
            @return="handleOrderReturn"
            @changeQuantity="handleQuantityChange"
            @finishEdit="handleFinishEdit"
            @showAddDishUI="showAddDishUI"
          />
        </div>

        <div v-if="currentTab === 'new'">
          <div v-for="(append, index) in awaitingAppends" :key="index" class="col-width">
            <QueueAppend
              :append="append"
              @toggleAvailability="handleAppendAvailabilityToggle"
              @accept="showAppendAcceptUI"
              @cancel="showAppendCancelUI"
            />
          </div>
        </div>
        <!-- <div class="archive-link-block mb-5" v-if="currentTab === 'done'">
          <router-link to="/archive" class="archive-link">{{ $t('queue.check_history') }}</router-link>
        </div>-->

        <img
          src="/icons/grey-logo.svg"
          alt="logo"
          class="mx-auto my-50 d-block"
        />
      </div>
    </div>

    <div v-if="connected && isDesktop && !anyModalIsActive">
      <div class="row">
        <PINLogin
          @confirm="onSharedPinEntered"
          @close="shared_strategy.asking_pin = false"
          ref="pinModal"
          v-if="shared_strategy.asking_pin"
        />

        <!-- OK SO NIGGA WHAT ABOUT CODE DUPLICATION ??? -->
        <div class="col kanban-column" id="new">
          <!-- <button
            class="btn-create-order"
            @click="showOrderCreateUI"
          >+ {{ $t('queue.create_order') }}</button>-->
          <p
            class="text-center color-black"
            v-if="!filterDesktopOrders('new').length && awaitingAppends.length === 0"
          >
            {{ $t("queue.no_orders") }}
          </p>
          <div v-for="item in filterDesktopOrders('new')" :key="item._id" class="col-width">
            <QueueItem
              :order="item"
              @cancel="showCancelUI"
              @toggleAvailability="handleAvailabilityToggle"
              @accept="showAcceptUI"
              @pay="showPayUI"
              @edit="showEditUI"
              @confirmPay="handleOrderClose"
              @discountChange="handleOrderDiscountChange"
              @changeTable="showMoveUI"
              @merge="showMergeUI"
              @split="showSplitUI"
              @unlock="showUnlockUI"
              @serve="handleOrderServe"
              @return="handleOrderReturn"
              @changeQuantity="handleQuantityChange"
              @finishEdit="handleFinishEdit"
              @showAddDishUI="showAddDishUI"
            />
          </div>

          <div>
            <div v-for="(append, index) in awaitingAppends" :key="index">
              <QueueAppend
                :append="append"
                @toggleAvailability="handleAppendAvailabilityToggle"
                @accept="showAppendAcceptUI"
                @cancel="showAppendCancelUI"
              />
            </div>
          </div>
        </div>
        <div class="col kanban-column" id="processing">
          <p
            class="text-center color-black"
            v-if="!filterDesktopOrders('processing').length"
          >
            {{ $t("queue.no_orders") }}
          </p>
          <div
            v-for="item in filterDesktopOrders('processing')"
            :key="item._id"
            class="col-width"
          >
            <QueueItem
              :order="item"
              @cancel="showCancelUI"
              @toggleAvailability="handleAvailabilityToggle"
              @accept="showAcceptUI"
              @pay="showPayUI"
              @edit="showEditUI"
              @confirmPay="handleOrderClose"
              @discountChange="handleOrderDiscountChange"
              @changeTable="showMoveUI"
              @merge="showMergeUI"
              @split="showSplitUI"
              @unlock="showUnlockUI"
              @serve="handleOrderServe"
              @return="handleOrderReturn"
              @changeQuantity="handleQuantityChange"
              @finishEdit="handleFinishEdit"
              @showAddDishUI="showAddDishUI"
            />
          </div>
        </div>
        <div class="col kanban-column" id="done">
          <p
            class="text-center color-black"
            v-if="!filterDesktopOrders('done').length"
          >
            {{ $t("queue.no_orders") }}
          </p>
          <div v-for="item in filterDesktopOrders('done')" :key="item._id" class="col-width">
            <QueueItem
              :order="item"
              @cancel="showCancelUI"
              @toggleAvailability="handleAvailabilityToggle"
              @accept="showAcceptUI"
              @pay="showPayUI"
              @edit="showEditUI"
              @confirmPay="handleOrderClose"
              @discountChange="handleOrderDiscountChange"
              @changeTable="showMoveUI"
              @merge="showMergeUI"
              @split="showSplitUI"
              @unlock="showUnlockUI"
              @serve="handleOrderServe"
              @return="handleOrderReturn"
              @changeQuantity="handleQuantityChange"
              @finishEdit="handleFinishEdit"
              @showAddDishUI="showAddDishUI"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Refuse WHOLE order -->
    <RefuseModal
      class="refuse-modal-block"
      @cancel="hideModalUI('cancel')"
      @confirm="handleOrderCancel"
      v-if="actions.cancel.active"
    />

    <!-- Accept and refuse some items -->
    <RefuseModal
      class="refuse-some-modal-block"
      :amount="actions.accept.refuseAmount"
      @cancel="hideModalUI('accept')"
      @confirm="handleOrderAccept"
      v-if="actions.accept.active"
    />

    <!-- Append refuse -->
    <RefuseModal
      class="refuse-modal-block"
      @cancel="hideModalUI('append_cancel')"
      @confirm="handleAppendCancel"
      v-if="actions.append_cancel.active"
    />

    <!-- Append refuse some -->
    <RefuseModal
      class="refuse-some-modal-block"
      :amount="actions.append_accept.refuseAmount"
      @cancel="hideModalUI('append_accept')"
      @confirm="handleAppendAccept"
      v-if="actions.append_accept.active"
    />

    <!-- Order Edit Modal -->
    <EditModal
      :cafe="cafe"
      :initialOrder="actions.edit.order"
      :menu="menu"
      @confirm="handleOrderEdit"
      @cancel="hideModalUI('edit')"
      v-if="actions.edit.active"
    />

    <!--- Merge Modal -->
    <MergeModal
      :cafe="cafe"
      :orders="actions.merge.orders"
      @merge="handleOrderMerge"
      @cancel="hideModalUI('merge')"
      v-if="actions.merge.active"
    />

    <!--- Split Modal -->
    <SplitModal
      :cafe="cafe"
      :order="actions.split.order"
      @split="handleOrderSplit"
      @cancel="hideModalUI('split')"
      v-if="actions.split.active"
    />

    <!-- Choose Table (move)-->
    <ChooseTable
      :sections="cafe.sections"
      :orders="orders"
      @select="handleOrderMove"
      @close="hideModalUI('move')"
      v-if="actions.move.active"
    />

    <!-- Choose Table (create order)-->
    <ChooseTable
      :sections="cafe.sections"
      :orders="orders"
      @select="switchToOrderCreate"
      @selectTable="emitSelectTable"
      @close="hideModalUI('create')"
      v-if="actions.create.active"
    />

    <!-- Add dish to check while editing -->
    <AddDish
      ref="addDish"
      class="add-dish-modal"
      editing_order
      @setCart="setCart"
      @select="dishSelect"
      @addMany="handleAddDish"
      @close="hideModalUI('add_dish')"
      v-if="actions.add_dish.active"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";

import StatusTabs from "@/components/StatusTabs";

import QueueItem from "@/components/QueueItem";
import QueueAppend from "@/components/QueueAppend";
import RefuseModal from "@/components/modals/RefuseModal.vue";
import EditModal from "@/components/modals/EditModal.vue";
import MergeModal from "@/components/modals/MergeModal.vue";
import SplitModal from "@/components/modals/SplitModal.vue";
import ChooseTable from "@/components/modals/ChooseTable.vue";
import PINLogin from "@/components/modals/Login.vue";
import AddDish from "@/components/modals/AddDish.vue";

import QueueService from "@/services/queue";
import QueueAPI from "@/api/queue";
import AuthAPI from "@/api/auth";

import SoundService from "@/services/sound";
import SharedQueueService from "@/services/shared";

import QueueTabs from "@/components/QueueTabs.vue"

import moment from "moment";

export default {
  data() {
    return {
      connected: false,
      currentTab: "new",
      isDesktop: false,
      hideStatusTabs: false,

      protectedOrders: {},

      busyAccepting: false,

      actions: {
        cancel: {
          order_id: null,
          active: false,
        },
        accept: {
          order_id: null,
          refuseAmount: 0,
          waiting_time: 0,
          active: false,
        },
        edit: {
          active: false,
          order: null,
        },
        merge: {
          active: false,
          orders: [],
        },
        split: {
          active: false,
          order: null,
        },
        append_accept: {
          active: false,
          order_id: null,
          append_index: -1,
          refuseAmount: 0,
          append: {},
        },
        append_cancel: {
          active: false,
          order_id: null,
          append_index: -1,
          append: {},
        },
        move: {
          active: false,
          order_id: null,
        },
        create: {
          active: false,
        },
        add_dish: {
          active: false,
          order_id: null,
        },
      },

      shared_strategy: {
        fn: null,
        args: [],

        pin: null,
        asking_pin: false,

        time: 0,
        timerId: 0,
      },
    };
  },

  methods: {
    setCart(cart) {
      this.$emit("setCart", cart);
    },
    addManyFromNavBar() {
      this.$refs.addDish.emitAddMany();
    },
    confirmFromNavbar() {
      this.$refs.addDish.uiContinue();
    },
    dishSelect() {
      this.$emit("dishSelect");
    },
    emitSelectTable(section, table) {
      this.$emit("selectTable", section, table);
    },
    toggleStatusTabs(isMenuActive) {
      this.hideStatusTabs = isMenuActive;
    },
    checkSharedQueue(fn, args) {
      if (this.$store.state.shared) {
        this.shared_strategy.fn = fn;
        this.shared_strategy.args = args;

        this.shared_strategy.asking_pin = true;
      } else {
        return true;
      }
    },
    switchQueueTab(tab) {
      this.currentTab = tab;
    },
    filterOrderForTab(order) {
      if (this.currentTab === "new") {
        return order.status === "waiting";
      }

      if (this.currentTab === "processing") {
        return (
          order.status === "serving" ||
          order.status === "served" ||
          order.status === "editing"
        );
      }

      if (this.currentTab === "done") {
        return order.status === "paying" || order.status === "executed";
      }

      return false;
    },
    fetchInitialOrders() {
      this.$store.dispatch("queue/fetchOrders").then(() => {
        if (this.tabsCounters.new > 0) {
          this.currentTab = "new";
        } else if (this.tabsCounters.processing > 0) {
          this.currentTab = "processing";
        } else if (this.tabsCounters.done > 0) {
          this.currentTab = "done";
        }
      });
    },
    connectToQueue() {
      if (!this.$store.state.shared && SharedQueueService.hasSharedStamp()) {
        if (!SharedQueueService.isValidStamp()) {
          this.returnToSharedSession();
          return;
        } else {
          let then = moment(SharedQueueService.getStampDate());

          const diff = moment().diff(then, "seconds");

          this.shared_strategy.time = Math.abs(diff);
          this.shared_strategy.timerId = setInterval(
            this.sharedQueueTick,
            1000
          );
        }
      }

      QueueService.init({
        onJoin: this.onQueueJoin,
        onNewOrder: this.onNewOrder,
        onHideOrder: this.removeOrderFromList,
        onPaymentRequest: this.onPaymentRequest,
        onOrderUpdate: this.onOrderUpdate,
      });
    },
    findOrderIndex(order_id) {
      let idx = -1;

      this.orders.forEach((order, index) => {
        if (order._id === order_id) {
          idx = index;
        }
      });

      return idx;
    },
    removeOrderFromList(order_id, force) {
      this.orders.forEach((order, idx) => {
        if (this.protectedOrders[order._id] && !force) return;

        if (order._id === order_id) {
          this.orders.splice(idx, 1);
          return;
        }
      });
    },
    protectOrder(order_id) {
      this.$set(this.protectedOrders, order_id, true);
    },
    unprotectOrder(order_id) {
      this.$delete(this.protectedOrders, order_id);
    },
    //UI
    // toggleGlobalScrolling(disable) {
    //   if (disable) {
    //     document.documentElement.scrollTop = 0;
    //   }

    //   document.body.style.overflow = disable ? "hidden" : "";
    //   document.body.style.height = disable ? "100%" : "";
    // },
    resetGlobalScrolling() {
      document.documentElement.scrollTop = 0;
    },
    hideModalUI(action) {
      this.actions[action].active = false;

      this.toggleGlobalScrolling(false);
    },
    showCancelUI(order_id) {
      if (!this.checkSharedQueue(this.showCancelUI, [order_id])) return;

      this.actions.cancel.order_id = order_id;
      this.actions.cancel.active = true;

      this.toggleGlobalScrolling(true);
    },
    showAcceptUI(order_id, time) {
      if (!this.checkSharedQueue(this.showAcceptUI, [order_id, time])) return;

      this.actions.accept.order_id = order_id;
      this.actions.accept.waiting_time = time;

      const order = this.orders[this.findOrderIndex(order_id)];

      let itemsRefuseAmount = 0;

      order.list.forEach((item) => {
        if (!item.available) itemsRefuseAmount++;
      });

      if (itemsRefuseAmount === 0) {
        this.handleOrderAccept();
      } else if (itemsRefuseAmount === order.list.length) {
        this.showCancelUI();
        this.actions.cancel.order_id = order_id;
      } else {
        this.actions.accept.active = true;
        this.actions.accept.refuseAmount = itemsRefuseAmount;
        this.toggleGlobalScrolling(true);
      }
    },
    showAppendAcceptUI(order_id, append_index) {
      // if (!this.checkSharedQueue(this.showAppendAcceptUI, [order_id, append_index]))
      //   return;

      const order_index = this.findOrderIndex(order_id);
      const order = this.orders[order_index];
      const append = order.appends[append_index];

      // if (order.waiter !== this.$store.state.waiter.name) {
      //   alert(this.$t("queue.not_your_order"));
      //   return;
      // }

      this.actions.append_accept.order_id = order_id;
      this.actions.append_accept.append_index = append_index;
      this.actions.append_accept.append = append;

      let itemsRefuseAmount = 0;

      append.list.forEach((item) => {
        if (!item.available) itemsRefuseAmount++;
      });

      if (itemsRefuseAmount == 0) {
        this.handleAppendAccept();
      } else if (itemsRefuseAmount === append.list.length) {
        this.actions.append_cancel.order_id = order_id;
        this.actions.append_cancel.append_index = append_index;
        this.showAppendCancelUI();
      } else {
        this.actions.append_accept.active = true;
        this.actions.append_accept.refuseAmount = itemsRefuseAmount;
        this.toggleGlobalScrolling(true);
      }
    },
    showPayUI(order_id) {
      if (!this.checkSharedQueue(this.showPayUI, [order_id])) return;

      const order_index = this.findOrderIndex(order_id);
      const order = this.orders[order_index];

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$store
        .dispatch("queue/payOrder", {
          order_id,
        })
        .then((ok) => {
          this.currentTab = "done";
        });
    },
    showEditUI(order_id) {
      if (!this.checkSharedQueue(this.showEditUI, [order_id])) return;

      const index = this.findOrderIndex(order_id);
      const order = JSON.parse(JSON.stringify(this.orders[index]));

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$store.commit("queue/setOrderStatus", {
        index,
        status: "editing",
      });

      this.$router.push({
        name: 'edit_action',
        params: {
          order_id: order._id
        }
      })
    },
    showMergeUI(order_id) {
      if (!this.checkSharedQueue(this.showMergeUI, [order_id])) return;

      const index = this.findOrderIndex(order_id);
      const order = this.orders[index];

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$router.push({
        name: "merge_action",
        params: {
          order_id: order._id,
        },
      });
      return;

      // const other = this.orders.filter((o, index) => {
      //   if (o._id === order_id) return false;

      //   if (o.status !== "paying") {
      //     return false;
      //   }

      //   if (o.table !== order.table || o.section !== order.section)
      //     return false;

      //   return true;
      // });

      // this.actions.merge.orders = [order].concat(other);
      // this.actions.merge.active = true;

      // this.toggleGlobalScrolling(true);
      this.resetGlobalScrolling();
    },
    showSplitUI(order_id) {
      if (!this.checkSharedQueue(this.showSplitUI, [order_id])) return;

      const index = this.findOrderIndex(order_id);

      const order = this.orders[index];

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      //
      this.$router.push({
        name: "split_action",
        params: {
          order_id: order._id,
        },
      });
      return;
      //

      this.actions.split.order = Object.assign({}, order);

      this.actions.split.active = true;
      this.resetGlobalScrolling();
    },
    showAppendCancelUI(order_id, append_index) {
      if (
        !this.checkSharedQueue(this.showAppendCancelUI, [
          order_id,
          append_index,
        ])
      )
        return;

      const index = this.findOrderIndex(order_id);
      const order = JSON.parse(JSON.stringify(this.orders[index]));

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.actions.append_cancel.active = true;
      this.actions.append_cancel.order_id = order_id;
      this.actions.append_cancel.append_index = append_index;
    },
    showMoveUI(order_id) {
      if (!this.checkSharedQueue(this.showMoveUI, [order_id])) return;

      const index = this.findOrderIndex(order_id);
      const order = JSON.parse(JSON.stringify(this.orders[index]));

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$router.push({
        name: "move_action",
        params: {
          order_id,
        },
      });

      // this.actions.move.active = true;
      // this.actions.move.order_id = order_id;
      // this.toggleGlobalScrolling(true);
    },
    showUnlockUI(order_id) {
      const index = this.findOrderIndex(order_id);

      this.$set(this.orders[index], "pay_method", "cash");
    },
    showOrderCreateUI() {
      this.$router.push("/create");
      // this.actions.create.active = !this.actions.create.active;
    },
    showAddDishUI(order_id) {
      this.actions.add_dish.active = true;
      this.actions.add_dish.order_id = order_id;
      this.$emit("addDish", this.actions);
    },
    onUiResize() {
      this.isDesktop = window.innerWidth > 767;
    },
    //Action handlers
    handleOrderCancel(reason) {
      this.$store
        .dispatch("queue/cancelOrder", {
          order_id: this.actions.cancel.order_id,
          reason,
        })
        .then((ok) => {
          this.hideModalUI("cancel");
        });
    },
    handleOrderAccept(optionalReason) {
      if (this.busyAccepting) return;
      
      this.protectOrder(this.actions.accept.order_id);

      const index = this.findOrderIndex(this.actions.accept.order_id);
      const list = this.orders[index].list.slice();
      this.busyAccepting = true;

      this.$store
        .dispatch("queue/acceptOrder", {
          order_id: this.actions.accept.order_id,
          list,
          reason: optionalReason,
          waiting_time: this.actions.accept.waiting_time,
        })
        .then((ok) => {
          this.hideModalUI("accept");

          if (this.filteredOrders.length == 0) {
            this.currentTab = "processing";
          }

          this.busyAccepting = false;
        }).catch(err => {
          this.busyAccepting = false;
        });
    },
    handleAppendAccept() {
      QueueAPI.acceptAppend(
        this.actions.append_accept.order_id,
        this.actions.append_accept.append_index,
        this.actions.append_accept.append.list
      )
        .then((data) => {
          this.hideModalUI("append_accept");

          if (this.filteredOrders.length == 0) {
            this.currentTab = "processing";
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
    handleAppendCancel(reason) {
      QueueAPI.cancelAppend(
        this.actions.append_cancel.order_id,
        this.actions.append_cancel.append_index,
        reason
      )
        .then((data) => {
          this.hideModalUI("append_cancel");

          if (this.filteredOrders.length == 0) {
            this.currentTab = "processing";
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
    handleAvailabilityToggle(order_id, itemIndex) {
      const index = this.findOrderIndex(order_id);

      const value = this.orders[index].list[itemIndex].available;

      this.$set(this.orders[index].list[itemIndex], "available", !value);
    },
    handleAppendAvailabilityToggle(order_id, append_index, item_index) {
      const index = this.findOrderIndex(order_id);

      const append = this.orders[index].appends[append_index];

      const value = append.list[item_index].available;

      this.$set(
        this.orders[index].appends[append_index].list[item_index],
        "available",
        !value
      );
    },
    handleOrderEdit(order) {
      this.$store
        .dispatch("queue/editOrder", {
          order_id: this.actions.edit.order._id,
          list: order.list,
          appends: order.appends,
        })
        .then((ok) => {
          this.hideModalUI("edit");
        });
    },
    handleOrderClose(order_id, data) {
      if (!this.checkSharedQueue(this.handleOrderClose, [order_id, data]))
        return;

      const index = this.findOrderIndex(order_id);
      const order = JSON.parse(JSON.stringify(this.orders[index]));

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$store.dispatch("queue/closeOrder", {
        order_id,
        pay_method: data.pay_method,
        discount: data.discount,
      });
    },
    handleOrderMove(newSection, newTable) {
      this.$store
        .dispatch("queue/moveOrder", {
          order_id: this.actions.move.order_id,
          section: newSection,
          table: newTable,
        })
        .then((ok) => {
          this.hideModalUI("move");
        });
    },
    handleOrderMerge(primary, secondary) {
      this.$store
        .dispatch("queue/mergeOrders", {
          primary,
          secondary,
        })
        .then((ok) => {
          this.hideModalUI("merge");
        });
    },
    handleOrderDiscountChange(order_id, value) {
      const index = this.$store.getters["queue/getOrderIndex"](order_id);

      this.$store.commit("queue/setOrderDiscount", {
        index,
        discount: value,
      });
    },
    handleOrderSplit(list) {
      QueueAPI.splitOrders(this.actions.split.order._id, list)
        .then((data) => {
          this.hideModalUI("split");
        })
        .catch((error) => {
          alert(error);
        });
    },
    handleOrderReturn(order_id) {
      if (!this.checkSharedQueue(this.handleOrderReturn, [order_id])) return;

      const index = this.findOrderIndex(order_id);
      const order = JSON.parse(JSON.stringify(this.orders[index]));

      if (order.waiter !== this.$store.state.waiter.name) {
        alert(this.$t("queue.not_your_order"));
        return;
      }

      this.$store.dispatch("queue/returnOrder", {
        order_id,
      });
    },
    handleQuantityChange(order_id, item_index, delta) {
      const index = this.findOrderIndex(order_id);

      this.$store.commit("queue/changeOrderItemQuantity", {
        index,
        item_index,
        delta,
      });
    },
    handleFinishEdit(order_id) {
      this.$store.dispatch("queue/editOrder", {
        order_id,
      });
    },
    handleAddDish(items) {
      const index = this.findOrderIndex(this.actions.add_dish.order_id);

      items.forEach((item) => {
        this.$store.commit("queue/addItemToOrderList", {
          index,
          item,
        });
      });

      this.actions.add_dish.active = false;
    },
    handleOrderServe(order_id) {
      this.$store.dispatch("queue/serveOrder", {
        order_id,
      });
    },
    switchToOrderCreate(section, table) {
      this.hideModalUI("create");

      this.$router.push({
        name: "create_order",
        params: {
          section,
          table,
        },
      });
    },
    sharedQueueTick() {
      this.shared_strategy.time--;

      if (this.shared_strategy.time == 0) {
        clearInterval(this.shared_strategy.timerId);

        this.returnToSharedSession();
      }
    },
    runCachedAction() {
      this.shared_strategy.fn.apply(this, this.shared_strategy.args);

      this.shared_strategy.time = 10;

      this.shared_strategy.timerId = setInterval(this.sharedQueueTick, 1000);
    },
    onSharedPinEntered(pin) {
      if (this.shared_strategy.asking_pin) {
        AuthAPI.loginSharedWaiter(pin)
          .then((data) => {
            SharedQueueService.updateStampTime();
            this.$store
              .dispatch("fetchWaiter")
              .then((ok) => {
                this.shared_strategy.asking_pin = false;
                this.runCachedAction();
              })
              .catch((error) => {
                this.$store.commit("setError", error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.$refs.pinModal.playError();
          });
      }
    },
    returnToSharedSession() {
      AuthAPI.switchSession(SharedQueueService.getStampSid())
        .then((data) => {
          this.$store
            .dispatch("fetchWaiter")
            .then(() => {
              this.connectToQueue();
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //Service Handlers
    onQueueJoin() {
      this.connected = true;

      this.fetchInitialOrders();
    },
    onNewOrder(order) {
      this.$store.commit("queue/addOrder", order);

      SoundService.playNewOrder();
    },
    onPaymentRequest(order_id, method) {
      //this is not relevant, as payment requests send socket 'update' event
      //you may send some sort of popup notification later
    },
    onOrderUpdate(order) {
      this.$store.commit("queue/updateOrder", order);
    },
    filterDesktopOrders(criteria) {
      const list = this.orders.filter((order) => {
        const status = order.status;

        if (criteria === "new") {
          return status === "waiting";
        }

        if (criteria === "processing") {
          return status === "serving" || status === "editing";
        }

        if (criteria === "done") {
          return status === "paying" || status === "executed";
        }
      });

      if (criteria == "processing") {
        const servingList = list.filter(
          (o) =>
            (o.status === "serving" || o.status == "editing") && !o.served_at
        );
        const servedList = list.filter((o) => !!o.served_at);

        return [].concat(servingList, servedList);
      }

      return list;
    },
  },
  computed: {
    filteredOrders() {
      const list = this.orders.filter(this.filterOrderForTab);

      if (this.currentTab != "processing") {
        return list;
      }

      const servingList = list.filter(
        (o) => (o.status === "serving" || o.status == "editing") && !o.served_at
      );
      const servedList = list.filter((o) => !!o.served_at);

      return [].concat(servingList, servedList);
    },
    awaitingAppends() {
      let appends = [];

      this.orders.forEach((order, index) => {
        if (order.appends && order.appends.length > 0) {
          order.appends.forEach((append, append_index) => {
            if (append.status === "waiting") {
              appends.push({
                order_id: order._id,
                data: {
                  list: append.list,
                  date: append.date,
                  client: order.client,
                  comment: append.comment,
                  status: append.status,
                  table: order.table,
                  section: order.section,
                },
                append_index,
              });
            }
          });
        }
      });

      return appends;
    },
    tabsCounters() {
      return this.$store.getters["queue/tabCounters"];
    },
    anyModalIsActive() {
      return (
        this.actions.merge.active ||
        this.actions.split.active ||
        this.actions.move.active
      );
    },
    //
    // Vuex Mapping
    //
    cafe() {
      return this.$store.state.cafe;
    },
    orders() {
      return this.$store.state.queue.orders;
    },
    menu() {
      return this.$store.state.menu;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onUiResize, false);

    this.onUiResize();

    // this.$router.push('/preorder');
    this.connectToQueue();
    // this.$store
    //   .dispatch("init")
    //   .then(ok => {
    //     this.connectToQueue();
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     this.$router.push("/login");
    //   });
  },
  components: {
    Navbar,
    StatusTabs,
    QueueItem,
    QueueAppend,
    RefuseModal,
    EditModal,
    MergeModal,
    SplitModal,
    ChooseTable,
    PINLogin,
    AddDish,
    QueueTabs
  },
};
</script>

<style scoped>
.queue-container {
  background: #ededed;
  min-height: 100vh;
}

.row {
  min-height: 100vh;
  overflow: auto !important;
  margin: 0 !important;
  /* padding: 0 20px; */
}

.pt-5 {
  padding-top: 7vh !important;
}

.desktop-new-orders,
.desktop-processing-orders,
.desktop-done-orders {
  border-right: 2px solid #ededed;
  padding-top: 140px;
  max-height: 100vh;
  padding-left: 30px;
  padding-right: 30px;
  overflow: hidden !important;
  overflow-y: visible !important;
}

.desktop-done-orders {
  border: none !important;
}

.queue-navbar-container {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 2;
}

.my-50 {
  margin: 6.2vh 0 12vh;
}

.alert-info {
  width: 90%;
  margin: 0px auto;
  margin-bottom: 20px;
}

.refuse-modal-block {
  z-index: 10;
}

.no-orders {
  margin: 2.9vh 0;
  text-align: center;
}

.btn-create-order {
  margin: 0 auto 2.5vh;
  width: 90%;
  font-size: 4.3vw;
  color: #1d1d1d;
  line-height: normal;
  font-weight: 500;
  display: block;
  padding: 1.5vh 0;
  border: 1px solid #1d1d1d;
  background: transparent;
  border-radius: 5vh;
}

 

.connecting-block {
  text-align: center;
  padding: 55px 15px 15px 15px;

  margin-top: 12vh;
}

::-webkit-scrollbar {
  width: 0px !important;
}
.lines {
  display: none;
}

.add-dish-modal {
  position: absolute;
  top: 0vh;
  left: 0;
  z-index: 2;
}



@media (min-width: 768px) {
  .col-width {
  width: 80%;
}
  div.col {
    display: flex;
    /* justify-content: center; */
    height: auto;
  }

  div.lines {
    display: flex;
    position: absolute;
    top: 9.722vw;
    right: 0;
    width: 100%;
  }
  .tabs-wrapper {
    position: fixed;
    width: 100%;
    z-index: 2;
    top: 6.5vh;
  }

  
  .lines .row {
    width: 100%;
    margin-left: 0;
  }
  .lines .row .col {
    border-right: 0.1vw solid #a4a3a1;
  }
  .lines .row .col:nth-child(3) {
    border: none;
  }
  .blur {
    position: absolute;
    top: -1px;
    width: 100%;
    height: 65vh;
    z-index: 0;
    background: #00000080;
    backdrop-filter: blur(3px);
  }

  .row {
    padding: 0;
  }

  .btn-create-order {
    margin: 0 auto 2.3vh;
    padding: 1.5vh;
    width: 38vh;
    font-size: 1.8vh;
    height: auto;
    border: 0.2222vh solid #129b81;
  }

  .desktop-done-orders {
    padding-right: 0 !important;
    margin-right: 0 !important;
  }
  p.text-center {
    font-size: 1.111vw;
     margin:0;
  }
}
</style>
